import { Box, CircularProgress, Checkbox, Grid, Typography, MenuItem, Autocomplete, TextField, Card, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Paper, Divider, Button, Rating, Avatar, Modal } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { BookingService } from '../Service';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Add, Delete, Refresh, Remove } from '@mui/icons-material';
import { ProviderServices } from '../../Provider/CrudServices';
import { BookingDataContext, DataContext, StepperDataContext } from './AddBooking';
import { useParams } from 'react-router-dom';
import { deepPurple, orange } from '@mui/material/colors';
import { CustomerService } from '../../Customer/Service';
import Swal from 'sweetalert2';
import { User } from '../../Provider/UserService';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ExpertAndServices = ({ fetchCartDetails, fetchAddressList, completeStep1 }) => {
    // const {id} = useParams();

    const {
        chargeDetails,
        setChargeDetails,
        bookingInitiationData,
        setExpertDetails,
        cartItems,
    } = useContext(BookingDataContext);

    const {
        categoryList,
        setCategoryList,
        subCategoryList,
        setSubCategoryList,
        expertList,
        setExpertList,
        serviceList,
        setServiceList
    } = useContext(DataContext);

    const {
        control,
        watch,
        formState: { isDirty },
        setValue
    } = useFormContext();

    const selectedCustomer = watch('customer');
    const selectedAddress = watch('selected_address');
    const categoryId = watch('categoryId');
    const subCategoryId = watch('subCategoryId');
    const serviceExpert = watch('serviceExpert');

    // Loading states
    const [loadingCategoryList, setLoadingCategoryList] = useState(false);
    const [loadingSubCategoryList, setLoadingSubCategoryList] = useState(false);
    const [loadingServiceExpertList, setLoadingServiceExpertList] = useState(false);
    const [loadingServiceList, setLoadingServiceList] = useState(false);

    const setDefaultAddress = async () => {
        try {
            const response = await CustomerService.updateCustomerDefaultAddress({
                "customerId": selectedCustomer?.id,
                "defaultAddress": selectedAddress?.id,
                "longitude": selectedAddress?.longitude,
                "latitude": selectedAddress?.latitude,
                "address": selectedAddress?.address
            });
            if (response.success == '1') {
                fetchAddressList();
            }
        } catch (error) {
            console.log("error:", error);
        }
    }

    // Fetch category list when coordinates are available
    useEffect(() => {
        if (selectedAddress?.latitude && selectedAddress?.longitude) {
            console.log("selectedAddress:", selectedAddress);
            if (selectedAddress?.isDefault) {
                fetchCategoryList();
                fetchCartDetails();
            } else {
                setDefaultAddress();
            }
        }
    }, [selectedAddress]);

    const fetchCategoryList = async () => {
        setLoadingCategoryList(true);
        try {
            const categoryListResponse = await BookingService.categoryListByCoordinates({ latitude: selectedAddress?.latitude, longitude: selectedAddress?.longitude });
            if (categoryListResponse.success === 1) {
                setCategoryList(categoryListResponse.data)
            }
        } catch (error) {

        } finally {
            setLoadingCategoryList(false);
        }
    }

    useEffect(() => {
        if (categoryId && selectedAddress?.latitude && selectedAddress?.longitude) {
            console.log("entery into fetching sub category list");
            // Only reset if not in edit mode OR if category changed from the original value
            if (categoryId !== bookingInitiationData.categoryId) {
                setValue('subCategoryId', '');
                setValue('serviceExpert', '');
            }
            console.log("latitude:", selectedAddress?.latitude);
            console.log("longitude:", selectedAddress?.longitude);
            const fetchSubCategoryList = async () => {
                setLoadingSubCategoryList(true);

                try {
                    const subCategoryListResponse = await BookingService.subCategoryListByCoordinatesAndCategoryId({
                        latitude: selectedAddress?.latitude,
                        longitude: selectedAddress?.longitude,
                        categoryId,
                    });
                    // console.log("subCategoryListResponse:",subCategoryListResponse);
                    if (subCategoryListResponse.success == '1') {
                        setSubCategoryList(subCategoryListResponse.data);
                    }
                } catch (error) {
                    // console.error("Failed to fetch sub-category list:", error);
                } finally {
                    setLoadingSubCategoryList(false);
                }
            };
            fetchSubCategoryList();
        }
    }, [categoryId, selectedAddress]);


    // whenever subcategory changes reset all the dependent fields like serviceexpert,services and fech service list and fetch service expert list
    const fetchExpertList = async () => {
        setLoadingServiceExpertList(true);

        try {
            const providerListResponse = await BookingService.providerListByCoordinatesAndSubCategoryId({
                latitude: selectedAddress?.latitude,
                longitude: selectedAddress?.longitude,
                subCategoryId,
            });
            console.log("providerListResponse:", providerListResponse);
            if (providerListResponse.success === 1) {
                setExpertList(providerListResponse.data);
            }
        } catch (error) {
            // console.error("Failed to fetch service list:", error);
        } finally {
            setLoadingServiceExpertList(false);
        }
    };
    useEffect(() => {
        if (subCategoryId && selectedAddress?.latitude && selectedAddress?.longitude) {
            // Only reset if not in edit mode OR if category changed from the original value
            console.log("entery into subcategory");
            // console.log("id:",id);
            console.log("bookingInitiationData.subCategoryId:", bookingInitiationData.subCategoryId);
            console.log("subCategoryId:", subCategoryId);
            if (subCategoryId !== bookingInitiationData.subCategoryId) {
                setValue('serviceExpert', '');
                // setValue('services', []);
            }

            fetchExpertList();
        }
    }, [subCategoryId, selectedAddress]);


    const fetchSelectedExpertData = async () => {
        try {
            const response = await ProviderServices.fetchProviderDetailsById(serviceExpert);
            const expertDetails = {
                ...response.data?.UserProfile,
                mobileNumber: response.data?.mobileNumber,
            }
            setExpertDetails(expertDetails);
            if (response.success === 1) {
                setChargeDetails({ ...chargeDetails, waiveVisitCharge: response.data?.UserProfile?.waiveVisitCharge });
            }
        } catch (error) {
            console.log("error:", error);
        }
    }
    // whenever serviceExpert changes reset all the dependent fields like services and fetch service list
    useEffect(() => {
        if (serviceExpert && subCategoryId) {
            fetchSelectedExpertData();
            const fetchServiceList = async () => {
                setLoadingServiceList(true);

                try {
                    const serviceListResponse = await BookingService.serviceList({ subCategoryId: subCategoryId, providerId: serviceExpert });
                    console.log("serviceListResponse:", serviceListResponse);
                    if (serviceListResponse.success === 1) {
                        const fetchedServiceList = serviceListResponse.data;
                        setServiceList(fetchedServiceList);
                        const cart = cartItems.find(cart => cart.providerId === serviceExpert);
                        if (cart) {
                            // const service = cart.relatedData.find(service => service.providerServiceId === details.option.id);
                            // accrding to each service in cart find from service list and setselected service
                            const cartServices = cart.relatedData.map(service => {
                                return fetchedServiceList.find(item => item.id === service.providerServiceId)
                            })
                            console.log("selectedServices:", cartServices);
                            setSelectedServices(cartServices);
                        }
                    }

                } catch (error) {
                    // console.error("Failed to fetch service list:", error);
                } finally {
                    setLoadingServiceList(false);
                }
            };
            fetchServiceList();
        }
    }, [serviceExpert, subCategoryId]);

    const [updatingServiceQuantity, setUpdatingServiceQuantity] = useState(false);
    const [deletingService, setDeletingService] = useState(false);

    const handleQuantityChange = async (item, quantity) => {
        setUpdatingServiceQuantity(true);
        console.log('item:', item);
        console.log('quantity:', quantity);
        const requiredCartData = {
            "customerId": item?.customerId,                            // Customer Id required for only admin      
            "services": [
                {
                    "provoiderServiceId": item?.providerServiceId,
                    "providerId": item?.providerId,
                    "quantity": quantity < 0 ? 0 : quantity,
                }
            ]
        }
        const updateresponse = await BookingService.createNewCart(requiredCartData);
        console.log("updateresponse:", updateresponse);
        if (updateresponse.success == '1') {
            await fetchCartDetails();
            if (selectedServices.length > 0 && quantity < 1) {
                // remove service from selectedServices
                setSelectedServices(selectedServices.filter(service => service?.id != item?.providerServiceId));
            }
        }
        setUpdatingServiceQuantity(false);
    };

    const handleDeleteService = async (item) => {
        setDeletingService(true);
        const requiredCartData = {
            "customerId": item?.customerId,                            // Customer Id required for only admin
            "services": [
                {
                    "provoiderServiceId": item?.providerServiceId,
                    "providerId": item?.providerId,
                    "quantity": 0,
                }
            ]
        }
        const deleteResponse = await BookingService.createNewCart(requiredCartData);
        console.log("deleteResponse:", deleteResponse);
        if (deleteResponse.success == '1') {
            await fetchCartDetails();
            if (selectedServices.length > 0) {
                setSelectedServices(selectedServices.filter(service => service?.id != item?.providerServiceId));
                // setSelectedServices(selectedServices.filter(service => service.id !== item.providerServiceId && service.serviceExpert !== item.providerId));
            }
        }
        setDeletingService(false);
    };
    const [selectedServices, setSelectedServices] = useState([]);
    const [lastClickedService, setLastClickedService] = useState(null);
    const [cartServiceModification, setCartServiceModification] = useState(false);
    const handleServiceChange = async (event, newValues, reason, details) => {
        setCartServiceModification(true);
        setOpenServiceDropdown(true)
        // The 'details' parameter gives information about what changed
        console.log("selected customer:", selectedCustomer)
        if (details && details.option) {
            console.log("Just clicked:", details.option);
            //   setLastClickedService(details.option);
            // const providerId = details.option.providerId;
            const cart = cartItems.find(cart => cart.providerId === serviceExpert);
            if (cart) {
                const service = cart.relatedData.find(service => service.providerServiceId === details.option.id);
                if (service) {
                    const quantity = service.quantity + 1;
                    const requiredCartData = {
                        "customerId": selectedCustomer.id,                            // Customer Id required for only admin
                        "services": [
                            {
                                "provoiderServiceId": details.option.id,
                                "providerId": serviceExpert,
                                "quantity": quantity,
                            }
                        ]
                    }
                    const updateresponse = await BookingService.createNewCart(requiredCartData);
                    console.log("updateresponse:", updateresponse);
                    if (updateresponse.success == '1') {
                        fetchCartDetails();
                    }
                } else {
                    const requiredCartData = {
                        "customerId": selectedCustomer.id,                            // Customer Id required for only admin
                        "services": [
                            {
                                "provoiderServiceId": details.option.id,
                                "providerId": serviceExpert,
                                "quantity": 1,
                            }
                        ]
                    }
                    const cretaeResponse = await BookingService.createNewCart({
                        "customerId": selectedCustomer.id,
                        "services": [
                            {
                                "provoiderServiceId": details.option.id,
                                "providerId": serviceExpert,
                                "quantity": 1
                            }
                        ]
                    });
                    console.log("cretaeResponse:", cretaeResponse);
                    if (cretaeResponse.success == '1') {
                        fetchCartDetails();
                    }
                }
            } else {
                const cretaeResponse = await BookingService.createNewCart({
                    "customerId": selectedCustomer?.id,
                    "services": [
                        {
                            "provoiderServiceId": details.option.id,
                            "providerId": serviceExpert,
                            "quantity": 1
                        }
                    ]
                });
                console.log("cretaeResponse:", cretaeResponse);
                if (cretaeResponse.success == '1') {
                    await fetchCartDetails();
                }
            }

            setSelectedServices(pre => [...pre, { ...details.option, serviceExpert: serviceExpert }]);
            setCartServiceModification(false);
            // setOpenServiceDropdown(false);
            console.log("selectedServices:", selectedServices);
        }
    };

    const [disableSlotButton, setDisableSlotButton] = useState(false);
    useEffect(() => {
        let swalInstance;
        let title = "Please wait"; // Default title

        // if (cartServiceModification) {
        //     title = "Updating Cart...";
        // } else 
        if (disableSlotButton) {
            title = "Fetching Available Slots...";
        } else if (updatingServiceQuantity) {
            title = "Updating Service Quantity...";
        } else if (deletingService) {
            title = "Removing Service from cart...";
        }

        if (disableSlotButton || updatingServiceQuantity || deletingService) {
            swalInstance = Swal.fire({
                // title: cartServiceModification ? 'Updating Cart' : 'Please wait While fetching slot',
                title: title,
                // html: 'Please wait',
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        } else if (swalInstance) {
            Swal.close();
        }

        return () => {
            if (swalInstance) {
                Swal.close();
            }
        };
    }, [disableSlotButton, updatingServiceQuantity, deletingService]);

    const handleRefreshList = async () => {
        await ProviderServices.refreshMaterializedView();
        fetchExpertList();
    }
    const [openServiceDropdown, setOpenServiceDropdown] = useState(false);
    return (
        <>
            <Grid container spacing={{ xs: 1, md: 2 }}>
                {/* ............left section................... */}
                <Grid item xs={12} sm={6} md={5}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins', color: (!selectedAddress?.latitude && !selectedAddress?.longitude) && 'lightGray' }}>Select Category<span style={{ color: (!selectedAddress?.latitude && !selectedAddress?.longitude) ? 'lightGray' : '#d32f2f' }}>*</span></Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Controller
                            name='categoryId'
                            control={control}
                            rules={{ required: 'select category' }}
                            render={({ field, fieldState: { error } }) => (
                                <Autocomplete
                                    fullWidth
                                    {...field}
                                    disabled={!selectedAddress?.latitude && !selectedAddress?.longitude}
                                    options={categoryList}
                                    getOptionLabel={(option) => option?.catTitle || ''}
                                    isOptionEqualToValue={(option, value) =>
                                        option.catId === (value?.catId || value)
                                    }
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue ? newValue.catId : null);
                                    }}
                                    value={categoryList.find(option => option.catId === field.value) || null}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label="Select SAC Code*"
                                            placeholder='Search and Select Category'
                                            error={!!error}
                                            // helperText={error ? error.message : ''}
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps,
                                                style: { fontSize: '0.75rem' }
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                            {option.catTitle || ''}
                                        </MenuItem>
                                    )}
                                />
                            )}
                        />
                        {loadingCategoryList && <CircularProgress />}
                    </Box>
                </Grid>
                <Grid item md={2} sx={{ display: { xs: 'none', md: 'block' } }} />
                <Grid item xs={12} sm={6} md={5}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins', color: !categoryId && 'lightGray' }}>Select Sub-Category<span style={{ color: !categoryId ? 'lightGray' : '#d32f2f' }}>*</span></Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Controller
                            name='subCategoryId'
                            control={control}
                            rules={{ required: 'select sub-category' }}
                            render={({ field, fieldState: { error } }) => (
                                <Autocomplete
                                    fullWidth
                                    {...field}
                                    disabled={!categoryId}
                                    options={subCategoryList || []}
                                    getOptionLabel={(option) => option?.subCatTitle || ''}
                                    isOptionEqualToValue={(option, value) =>
                                        option.subCatId === (value?.subCatId || value)
                                    }
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue ? newValue.subCatId : null);
                                    }}
                                    value={subCategoryList.find(option => option.subCatId === field.value) || null}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label="Select SAC Code*"
                                            placeholder='Search and Select Sub-Category'
                                            error={!!error}
                                            // helperText={error ? error.message : ''}
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps,
                                                style: { fontSize: '0.75rem' }
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                            {option.subCatTitle || ''}
                                        </MenuItem>
                                    )}
                                />
                            )}
                        />
                        {loadingSubCategoryList && <CircularProgress />}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={5}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '1%' }}>
                        <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins', color: !selectedCustomer && 'lightGray' }}>Select Expert<span style={{ color: !selectedCustomer ? 'lightGray' : '#d32f2f' }}>*</span></Typography>
                        <Button disabled={!subCategoryId} size='small' variant='contained' onClick={() => handleRefreshList()} startIcon={<Refresh sx={{ fontSize: '.85rem!important' }} />} sx={{ height: 'fit-content', fontSize: 'x-small', p: '.5% 1.25%' }}>Refresh List</Button>
                    </Box>
                    {/* <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!subCategoryId && 'lightGray'}}>Select Service Expert<span style={{color:!subCategoryId ? 'lightGray' : '#d32f2f'}}>*</span></Typography> */}
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Controller
                            name='serviceExpert'
                            control={control}
                            rules={{ required: 'Select Service Expert' }}
                            render={({ field, fieldState: { error } }) => (
                                <Autocomplete
                                    fullWidth
                                    {...field}
                                    disabled={!subCategoryId}
                                    options={expertList || []}
                                    // getOptionLabel={(option) => option?.subCatTitle || ''}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        const expertLabel = option?.firstName ? `${option.firstName} ${option.lastName}` : '';
                                        const mobileNumber = option?.mobileNumber ? `(${option.mobileNumber})` : '';
                                        const distance = option?.distance ? `(${option.distance} km)` : '';
                                        return `${expertLabel} | ${mobileNumber} | ${distance}`;
                                    }}
                                    isOptionEqualToValue={(option, value) =>
                                        option.userId === (value?.userId || value)
                                    }
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue ? newValue.userId : null);
                                    }}
                                    value={expertList.find(option => option.userId === field.value) || null}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label="Select SAC Code*"
                                            placeholder='Search and Select Expert'
                                            error={!!error}
                                            // helperText={error ? error.message : ''}
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps,
                                                style: { fontSize: '0.75rem' }
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                            {option.firstName || '' + option.lastName || ''} | {option.mobileNumber || ''} | {option.distance + ' ' + 'km' || ''}
                                        </MenuItem>
                                    )}
                                />
                            )}
                        />
                        {loadingServiceExpertList && <CircularProgress />}
                    </Box>
                </Grid>
                {/* <Grid item xs={2} sx={{display:'flex',alignItems:'flex-end'}}>                
                <Button disabled={!subCategoryId} size='small' variant='contained' sx={{textTransform:'none'}} onClick={handleRefreshList}>Refresh List</Button>
            </Grid> */}

            </Grid>

            <Divider sx={{ my: '2%', borderBlockStyle: 'dashed', borderBlockWidth: '1px' }} />

            <Grid container spacing={2} >
                <Grid item xs={12} sm={6} md={5}>
                    <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', fontFamily: 'Poppins', color: !serviceExpert && 'lightGray' }}>Select Services<span style={{ color: !serviceExpert ? 'lightGray' : '#d32f2f' }}>*</span></Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>

                        <Autocomplete
                            fullWidth
                            multiple
                            disabled={!serviceExpert}
                            disableCloseOnSelect
                            disableClearable
                            open={openServiceDropdown}
                            onOpen={() => setOpenServiceDropdown(true)}
                            onClose={(event, reason) => {
                                // Allow closing on specific user actions, but prevent during cart modification
                                if (cartServiceModification) {
                                    // Prevent closing during cart modification
                                    event.preventDefault();
                                } else if (reason === 'toggleInput' || reason === 'escape' || reason === 'blur') {
                                    // Close on clicking outside (blur), pressing escape, or clicking the toggle button
                                    setOpenServiceDropdown(false);
                                }
                            }}
                            options={serviceList}
                            getOptionLabel={(option) => option?.title}
                            value={selectedServices}
                            renderOption={(props, option, { selected }) => (
                                <li {...props} key={option?.id} style={{ fontSize: '0.75rem' }} disabled={selected}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    <Typography sx={{fontSize:'.65rem'}}>{option?.title}{option.brand?.id !='1' && <Box component={'span'} sx={{color:'#1565c0'}}>_{option.brand?.title}</Box>}</Typography>
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { fontSize: '0.75rem', color: '#000' },
                                    }}
                                    size='small'
                                    // error={!!error}
                                    variant="outlined"
                                    placeholder="Select services"
                                />
                            )}
                            onChange={handleServiceChange}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderTags={() => null}
                        />

                        {loadingServiceList && <CircularProgress />}
                    </Box>
                </Grid>
                <Grid item xs={12} >
                    <Box>
                        <Typography sx={{ fontWeight: '600', color: '#494949' }}>Customer Cart</Typography>
                        <Card sx={{ bgcolor: '#dadada4d', position: 'relative' }} >
                            <Modal
                                open={cartServiceModification}
                                // onClose={() => setOpenServiceDropdown(false)}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                sx={{ overflow: "scroll" }}
                            >
                                <Box
                                    sx={{
                                        display:'flex',
                                        flexDirection:'column',
                                        justifyContent:'center',
                                        alignItems:'center',
                                        position: 'absolute',
                                        top: { xs: '80%', sm: '50%' },
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        bgcolor: 'background.paper',
                                        p: 0,
                                        width: { xs: "95%", sm: "25%" },
                                        minHeight:'25%'
                                    }}

                                    borderRadius={2}
                                >
                                    <Typography sx={{fontSize:'1.25rem',fontWeight:500,color:'#3e3e3e'}}>Updating Cart. Please wait....</Typography>
                                    <Box sx={{ position: 'relative', width: 40, height: 40 }}>
                                        <CircularProgress
                                            size={40}
                                            thickness={4}
                                            color="primary"
                                            variant="indeterminate"
                                            sx={{
                                                position: 'absolute',
                                                left: 0,
                                                color: (theme) => theme.palette.primary.main,
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Modal>
                            <Grid container>
                                <Grid item xs={12}>
                                    {
                                        cartItems.length > 0 ? cartItems.map((item, index) => (
                                            <Box key={index}>
                                                <Box sx={{ p: 1 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, p: 1 }}>
                                                        <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', sm: 'center' }, gap: 1 }}>
                                                            <Avatar sx={{ bgcolor: index % 2 === 0 ? deepPurple[500] : orange[500], width: { xs: 25, sm: 50 }, height: { xs: 25, sm: 50 }, borderRadius: '.5rem' }} variant="square">R</Avatar>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>{item?.firstName} {item?.lastName} ({item?.relatedData[0].User?.id})</Typography>
                                                                <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>Contact : {item?.relatedData[0].User?.mobileNumber}</Typography>
                                                                <Rating name="read-only" value={item?.relatedData[0].User?.UserProfile?.avgRating} readOnly size='small' />
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ pr: 1 }}>
                                                            <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}>Total Items: {item.relatedData.length}</Typography>
                                                            <Typography sx={{ fontSize: '.75rem', fontWeight: 600, color: '#3e3e3e' }}></Typography>
                                                        </Box>
                                                    </Box>
                                                    {/* { showIndex === index && */}
                                                    <Box component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
                                                        <Table sx={{ minWidth: 600 }}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} width="40%" >Service</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Quantity</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Time</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Price</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="center" width="12%">Total</TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, p: '1% 2%', fontSize: '.75rem' }} align="right" width="12%" >Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {item.relatedData.map((service) => (
                                                                    <TableRow key={service.id}>
                                                                        <TableCell sx={{ p: .5, fontSize: '.75rem' }}>{service.providerServiceCart.childService.title}<Box component='span' sx={{color:'#1565c0'}}>{service.providerServiceCart.brd?.id!=1 && `_${service.providerServiceCart.brd?.title}`}</Box></TableCell>
                                                                        <TableCell align="center" sx={{ p: .5, fontSize: '.75rem' }}>
                                                                            <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => handleQuantityChange(service, Math.max(0, service.quantity - 1))}
                                                                                >
                                                                                    <Remove sx={{ color: '#1A44B8' }} fontSize='small' />
                                                                                </IconButton>
                                                                                <Box sx={{ borderLeft: '1px solid #ccc', borderRight: '1px solid #ccc', padding: '.25rem .5rem' }}>
                                                                                    <Typography>
                                                                                        {service.quantity}
                                                                                    </Typography>
                                                                                </Box>

                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => handleQuantityChange(service, service.quantity + 1)}
                                                                                >
                                                                                    <Add fontSize='small' sx={{ color: '#1A44B8' }} />
                                                                                </IconButton>
                                                                            </Paper>
                                                                        </TableCell>
                                                                        <TableCell align="center" sx={{ p: .5, fontSize: '.75rem' }}>
                                                                            {(service.providerServiceCart.serviceTime) * service.quantity} mins
                                                                        </TableCell>
                                                                        <TableCell sx={{ p: .5, fontSize: '.75rem', textAlign: 'center' }}>₹{service.providerServiceCart.price}</TableCell>
                                                                        <TableCell sx={{ p: .5, fontSize: '.75rem', textAlign: 'right' }} >₹{parseFloat(service.providerServiceCart.price * service.quantity).toFixed(2)}</TableCell>
                                                                        <TableCell align="right" sx={{ p: .5, fontSize: '.75rem' }}>
                                                                            <IconButton
                                                                                aria-label="delete"
                                                                                onClick={() => handleDeleteService(service)}
                                                                                size="small"
                                                                                color='error'
                                                                            >
                                                                                <Delete sx={{ fontSize: '1rem' }} />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                    {/* } */}
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, gap: 2 }}>
                                                    <Button sx={{ textTransform: 'none' }} size='small' variant='contained' color='warning'
                                                        disabled={disableSlotButton}
                                                        onClick={() => {
                                                            setDisableSlotButton(true);
                                                            completeStep1(item)
                                                        }}
                                                    >
                                                        Select Slot
                                                    </Button>
                                                </Box>
                                                {index < cartItems.length - 1 && <Divider sx={{ my: '1%', borderColor: '#3a2bde' }} />}
                                            </Box>
                                        ))
                                            :
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                                <Typography sx={{ fontSize: '.75rem', fontWeight: 600 }}>No services in cart</Typography>
                                            </Box>
                                    }
                                </Grid>
                            </Grid>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
}

export default ExpertAndServices;
